export const routes = {
    Vercel: process.env.REACT_APP_NEWS_API_URL || "https://back-noticias-fisp-4.vercel.app",
    Hostinger: "https://srv452353.hstgr.cloud",
};

export const NEWS_API_BASE = routes.Vercel;

const utf8Decoder = new TextDecoder("utf-8");

function buildApiUrl(path, server = NEWS_API_BASE) {
    const base = String(server || NEWS_API_BASE).replace(/\/+$/, "");
    const cleanPath = String(path || "").replace(/^\/+/, "");

    return `${base}/${cleanPath}`;
}

export const fispTvSegments = [
    {
        label: "Inicio",
        slug: "ultimas",
        description: "La portada de FISP TV con los contenidos mas recientes y las publicaciones destacadas del multimedio.",
        sourceCategory: null,
        aliases: ["Inicio", "Ultimas", "Últimas"],
        accentColor: "#0a7e8c",
    },
    {
        label: "Desde Adentro",
        slug: "desde-adentro",
        description: "Descubrí el lado más íntimo de las figuras en un viaje profundo donde revelan sus verdades, sus miedos y lo que realmente los define.",
        sourceCategory: "Desde Adentro",
        aliases: ["Desde Adentro"],
        slugAliases: [],
        accentColor: "#c34608",
    },
    {
        label: "El Nudo",
        slug: "el-nudo",
        description: "En cada episodio derribamos mitos y tabúes entendiendo cómo y por qué se generaron para que al final, juntos, desatemos El Nudo.",
        sourceCategory: "El Nudo",
        aliases: ["El Nudo"],
        slugAliases: [],
        accentColor: "#8d6240",
    },
    {
        label: "Real Food",
        slug: "real-food",
        description: "Restaurantes, bodegones y cafés revelan cómo nace cada plato: desde la cocina hasta la mesa.",
        sourceCategory: "Real Food",
        aliases: ["Real Food"],
        slugAliases: [],
        accentColor: "#008c83",
    },
    {
        label: "Medicina 5.0",
        slug: "medicina-5",
        description: "Innovacion, salud digital, inteligencia artificial y nuevas herramientas aplicadas a la medicina.",
        sourceCategory: "Medicina 5.0",
        aliases: ["Medicina 5.0"],
        slugAliases: ["medicina-5-0"],
        accentColor: "#0c5a88",
    },
    {
        label: "Segunda Opinión",
        slug: "segunda-opinion",
        description: "Hablamos de salud con quienes más saben. Médicos y especialistas que explican, se animan a cuestionar y nos ayudan a entender los cambios que atraviesa la medicina actual.",
        sourceCategory: "2da Opinión",
        aliases: ["2da Opinion", "2da Opinión", "Segunda Opinion", "Segunda Opinión"],
        slugAliases: [],
        accentColor: "#c4b420",
    },
    {
        label: "Vida Sana",
        slug: "vida-sana",
        description: "Cada episodio es una nueva experiencia, una invitación a moverte distinto y a encontrar tu propio bienestar.",
        sourceCategory: "Vida Sana",
        aliases: ["Vida Sana"],
        slugAliases: [],
        accentColor: "#8d4063",
    },
    {
        label: "Inspirando el Cambio",
        slug: "inspirando-el-cambio",
        description: "Charlamos con los líderes que están haciendo realidad la transformación en salud.",
        sourceCategory: "Inspirando el Cambio",
        aliases: ["Inspirando el Cambio", "Inspirando el cambio"],
        slugAliases: [],
        accentColor: "#404d8d",
    },
    {
        label: "Editoriales",
        slug: "opinion",
        description: "Lecturas, opiniones y piezas editoriales para seguir la actualidad del ecosistema FISP con contexto.",
        sourceCategory: "Opinion",
        aliases: ["Editoriales", "Opinión"],
        slugAliases: ["editoriales"],
        accentColor: "#6d8d40",
    },
    {
        label: "Recetas",
        slug: "recetas",
        description: "Contenido gastronomico y de bienestar para llevar la salud tambien a la mesa.",
        sourceCategory: "Recetas",
        aliases: ["Recetas"],
        slugAliases: [],
        accentColor: "#b85a3c",
    },
];

export const fispTvSectionOrderSlugs = [
    "desde-adentro",
    "medicina-5",
    "el-nudo",
    "segunda-opinion",
    "inspirando-el-cambio",
    "opinion",
    "recetas",
    "real-food",
    "vida-sana",
];
export const fispTvSectionSegments = fispTvSectionOrderSlugs
    .map((slug) => fispTvSegments.find((segment) => segment.slug === slug))
    .filter(Boolean);
export const fispTvCategories = ["Inicio", ...fispTvSectionSegments.map((segment) => segment.label)];
export const fispTvHomeSectionSlugs = [
    "desde-adentro",
    "medicina-5",
    "el-nudo",
    "segunda-opinion",
    "inspirando-el-cambio",
];
export const fispTvHomeCategorySlugs = [
    "desde-adentro",
    "medicina-5",
    "el-nudo",
    "segunda-opinion",
    "inspirando-el-cambio",
    "opinion",
    "recetas",
    "real-food",
    "vida-sana",
];

const segmentBySlug = new Map();
const segmentLabelMap = new Map();

fispTvSegments.forEach((segment) => {
    [segment.slug, ...(segment.slugAliases || [])]
        .filter(Boolean)
        .forEach((value) => {
            segmentBySlug.set(String(value).trim().toLowerCase(), segment);
        });

    [segment.label, segment.sourceCategory, ...(segment.aliases || [])]
        .filter(Boolean)
        .forEach((value) => {
            segmentLabelMap.set(toCategoryKey(value), segment);
        });
});

export function isAbsoluteUrl(value) {
    return /^https?:\/\//i.test((value || "").trim());
}

export function normalizeUtf8Text(value) {
    if (typeof value !== "string" || !/[ÃƒÃ‚Ã¢]/.test(value)) {
        return value || "";
    }

    let nextValue = value;

    for (let index = 0; index < 2; index += 1) {
        if (!/[ÃƒÃ‚Ã¢]/.test(nextValue)) {
            break;
        }

        try {
            nextValue = utf8Decoder.decode(Uint8Array.from(nextValue, (character) => character.charCodeAt(0)));
        } catch {
            break;
        }
    }

    return nextValue;
}

function toCategoryKey(value) {
    return normalizeUtf8Text(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, " ")
        .trim()
        .toLowerCase();
}

export function resolveMediaUrl(value, server = NEWS_API_BASE) {
    const source = normalizeUtf8Text(value).trim();

    if (!source) {
        return "";
    }

    if (source.startsWith("data:") || isAbsoluteUrl(source)) {
        return source;
    }

    if (source.startsWith("/")) {
        return `${String(server || NEWS_API_BASE).replace(/\/+$/, "")}${source}`;
    }

    return buildApiUrl(source.replace(/^\.?\//, ""), server);
}

export function normalizeCategoryLabel(value) {
    const raw = normalizeUtf8Text(value).trim();

    if (!raw) {
        return "FISP TV";
    }

    const segment = segmentLabelMap.get(toCategoryKey(raw));

    if (segment) {
        return segment.label;
    }

    return raw.replace(/\b\p{L}/gu, (letter) => letter.toUpperCase());
}

export function slugifyCategory(value) {
    return normalizeCategoryLabel(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .toLowerCase();
}

export function findSegmentBySlug(slug) {
    return segmentBySlug.get((slug || "").trim().toLowerCase()) || null;
}

export function findSegmentByCategory(value) {
    return segmentLabelMap.get(toCategoryKey(value)) || null;
}

export function buildCategoryPath(value) {
    const segment = typeof value === "string" ? findSegmentBySlug(value) || findSegmentByCategory(value) : value;

    if (!segment || segment.slug === "ultimas") {
        return "/fisp-tv";
    }

    return `/fisp-tv/segmentos/${segment.slug}`;
}

export function getHomeSegments() {
    return fispTvHomeSectionSlugs
        .map((slug) => findSegmentBySlug(slug))
        .filter(Boolean);
}

export function getHomeCategorySections() {
    return fispTvHomeCategorySlugs
        .map((slug) => findSegmentBySlug(slug))
        .filter(Boolean);
}

export function buildNewsPath(slug) {
    return slug ? `/fisp-tv/${slug}` : "/fisp-tv";
}

export function buildNewsHref(item) {
    const slug = normalizeUtf8Text(item?.url || "").trim();

    if (slug) {
        return { href: buildNewsPath(slug), external: false };
    }

    const videoUrl = normalizeUtf8Text(item?.link_video || "").trim();

    if (isAbsoluteUrl(videoUrl)) {
        return { href: videoUrl, external: true };
    }

    return { href: "/fisp-tv", external: false };
}

export function getNewsTimestamp(item) {
    const rawDate = item?.fecha_habilitacion || item?.fecha || item?.created_at || item?.updated_at;
    const timestamp = rawDate ? new Date(rawDate).getTime() : Number.NaN;

    if (Number.isFinite(timestamp)) {
        return timestamp;
    }

    return Number(item?.id) || 0;
}

export function sortNewsByDate(items = []) {
    return [...items].sort((leftItem, rightItem) => getNewsTimestamp(rightItem) - getNewsTimestamp(leftItem));
}

export function sortNewsForHighlights(items = []) {
    return [...items].sort((leftItem, rightItem) => {
        const leftPinned = Number(leftItem.presente_home) === 1 || leftItem.presentInHome;
        const rightPinned = Number(rightItem.presente_home) === 1 || rightItem.presentInHome;

        if (leftPinned !== rightPinned) {
            return leftPinned ? -1 : 1;
        }

        const leftOrder = Number.isFinite(Number(leftItem.orden_home)) ? Number(leftItem.orden_home) : leftItem.homeOrder;
        const rightOrder = Number.isFinite(Number(rightItem.orden_home)) ? Number(rightItem.orden_home) : rightItem.homeOrder;

        if (leftPinned && rightPinned && leftOrder !== rightOrder) {
            return leftOrder - rightOrder;
        }

        return getNewsTimestamp(rightItem) - getNewsTimestamp(leftItem);
    });
}

export function extractYoutubeId(value) {
    const raw = normalizeUtf8Text(value).trim();

    if (!raw) {
        return "";
    }

    const embedMatch = raw.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{6,})/i);
    if (embedMatch) {
        return embedMatch[1];
    }

    const watchMatch = raw.match(/[?&]v=([a-zA-Z0-9_-]{6,})/i);
    if (watchMatch) {
        return watchMatch[1];
    }

    const shortMatch = raw.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/i);
    if (shortMatch) {
        return shortMatch[1];
    }

    return "";
}

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

function cleanNewsBodyHtml(value) {
    return String(value)
        .replace(/<p>\s*(?:<br\s*\/?>|&nbsp;|\u00a0|\s)*\s*<\/p>/gi, "")
        .replace(/<p>\s*<span[^>]*>\s*(?:<br\s*\/?>|&nbsp;|\u00a0|\s)*\s*<\/span>\s*<\/p>/gi, "")
        .replace(/(?:<br\s*\/?>\s*){2,}/gi, "<br />")
        .replace(/\s+(<\/h[23]>)/gi, "$1")
        .replace(/(<\/h[23]>)\s+(<p>)/gi, "$1$2")
        .trim();
}

export function normalizeBodyHtml(value) {
    const body = normalizeUtf8Text(value).trim();

    if (!body) {
        return "";
    }

    if (/<[a-z][\s\S]*>/i.test(body)) {
        return cleanNewsBodyHtml(body);
    }

    return body
        .split(/\n{2,}/)
        .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, "<br />")}</p>`)
        .join("");
}

export function normalizeNewsItem(item, server = NEWS_API_BASE) {
    const link = buildNewsHref(item);
    const category = normalizeCategoryLabel(item?.categoria);
    const segment = findSegmentByCategory(category);
    const youtubeId = extractYoutubeId(item?.link_video);

    return {
        ...item,
        id: item?.id ?? item?.url ?? Math.random().toString(36).slice(2),
        title: normalizeUtf8Text(item?.titulo || "Contenido FISP").trim(),
        category,
        categorySlug: segment?.slug || slugifyCategory(category),
        description: normalizeUtf8Text(item?.descripcion || "").trim(),
        image: resolveMediaUrl(item?.imagen, server),
        coverImage: resolveMediaUrl(item?.imagen_portada, server),
        href: link.href,
        external: link.external,
        slug: normalizeUtf8Text(item?.url || "").trim(),
        bodyHtml: normalizeBodyHtml(item?.cuerpo),
        publishedAt: item?.fecha_habilitacion || item?.fecha || "",
        youtubeId,
        embedUrl: youtubeId ? `https://www.youtube.com/embed/${youtubeId}` : "",
        relatedSlugs: [item?.art_rel_1, item?.art_rel_2, item?.art_rel_3].map((slug) => normalizeUtf8Text(slug).trim()).filter(Boolean),
        presentInHome: Number(item?.presente_home) === 1,
        homeOrder: Number.isFinite(Number(item?.orden_home)) ? Number(item.orden_home) : Number.POSITIVE_INFINITY,
    };
}

function normalizeNewsCollection(items = [], sortFn = sortNewsByDate, server = NEWS_API_BASE) {
    return sortFn(items.filter((item) => item && item.titulo).map((item) => normalizeNewsItem(item, server)));
}

function normalizeNewsPreviewItem(item, categoryOverride, server = NEWS_API_BASE) {
    return normalizeNewsItem({
        ...item,
        categoria: categoryOverride || item?.categoria,
        cuerpo: item?.cuerpo || "",
        fecha_habilitacion: item?.fecha_habilitacion || item?.fecha || "",
        link_video: item?.link_video || item?.linkVideo || "",
        presente_home: item?.presente_home || 0,
        orden_home: item?.orden_home,
    }, server);
}

async function fetchJson(url, signal) {
    const response = await fetch(url, { signal });

    if (!response.ok) {
        throw new Error(`No se pudo obtener ${url}`);
    }

    return response.json();
}

export async function fetchPublishedNews(signal, server = NEWS_API_BASE) {
    const result = await fetchJson(buildApiUrl("/noticias-hoy-dto-3", server), signal);

    if (!Array.isArray(result)) {
        return [];
    }

    return normalizeNewsCollection(result, sortNewsByDate, server);
}

export async function fetchHomeNews(signal, server = NEWS_API_BASE) {
    const result = await fetchJson(buildApiUrl("/home-dto-main", server), signal);

    if (!Array.isArray(result)) {
        return [];
    }

    return normalizeNewsCollection(result, sortNewsForHighlights, server).filter((item) => {
        if (!item.publishedAt) {
            return true;
        }

        const timestamp = new Date(item.publishedAt).getTime();

        return Number.isNaN(timestamp) || timestamp <= Date.now();
    });
}


export async function fetchMostViewedNews(signal, server = NEWS_API_BASE) {
    try {
        const result = await fetchJson(buildApiUrl("/noticias-mas-vistas", server), signal);

        if (!Array.isArray(result)) {
            return [];
        }

        const filtered = result.filter((item) => item && item.titulo);
        return filtered.map((item) => normalizeNewsItem(item, server));
    } catch (error) {
        if (error.name === "AbortError") {
            throw error;
        }
        console.error("Error cargando noticias más vistas:", error);
        return [];
    }
}

// ─── fetchPublishedNewsBySlug ─────────────────────────────────────────────────
// El parámetro contarVista (false por defecto) se usa exclusivamente desde
// Noticia.jsx, donde se pasa true para registrar la lectura real del usuario.
// Ninguna otra llamada en el sistema usa este parámetro, por lo que el contador
// solo sube cuando alguien abre la nota completa en el navegador.

export async function fetchPublishedNewsBySlug(slug, signal, server = NEWS_API_BASE, contarVista = false) {
    if (!slug) {
        return null;
    }

    const vistaParam = contarVista ? "?vista=1" : "";
    const result = await fetchJson(
        buildApiUrl(`/noticias-hoy/${encodeURIComponent(slug)}${vistaParam}`, server),
        signal
    );

    const noticia = Array.isArray(result) ? result[0] : null;

    if (!noticia) {
        return null;
    }

    return normalizeNewsItem(noticia, server);
}

export async function fetchRelatedNewsBySlug(slug, limit = 3, signal, server = NEWS_API_BASE) {
    if (!slug) {
        return [];
    }

    const result = await fetchJson(buildApiUrl(`/noticias-relacionadas-dto/${encodeURIComponent(slug)}?limit=${limit}`, server), signal);

    if (!Array.isArray(result)) {
        return [];
    }

    return normalizeNewsCollection(
        result.map((item) => normalizeNewsPreviewItem(item, undefined, server)),
        sortNewsByDate,
        server,
    ).slice(0, limit);
}

export async function fetchCategoryPreviewNews(category, signal, server = NEWS_API_BASE) {
    const segment = findSegmentByCategory(category) || findSegmentBySlug(category);
    const slug = segment?.slug || slugifyCategory(category);

    if (segment?.slug === "recetas") {
        const result = await fetchJson(buildApiUrl("/noticias-hoy-dto-3", server), signal);

        if (!Array.isArray(result)) {
            return [];
        }

        const targetKeys = [segment.sourceCategory, segment.label, ...(segment.aliases || [])]
            .filter(Boolean)
            .map((value) => toCategoryKey(value));

        const filteredItems = result.filter((item) => {
            const rawCategory = normalizeUtf8Text(item?.categoria || "").trim();
            return targetKeys.includes(toCategoryKey(rawCategory));
        });

        return normalizeNewsCollection(
            filteredItems.map((item) => normalizeNewsPreviewItem(item, segment.label, server)),
            sortNewsByDate,
            server,
        ).slice(0, 4);
    }

    const result = await fetchJson(buildApiUrl(`/noticias-categoria-ultimas-4-dto-3/${encodeURIComponent(slug)}`, server), signal);

    if (!Array.isArray(result)) {
        return [];
    }

    return normalizeNewsCollection(
        result.map((item) => normalizeNewsPreviewItem(item, segment?.label, server)),
        sortNewsByDate,
        server,
    ).slice(0, 4);
}

export async function fetchSectionCollections(categories = [], limit = 3, signal, server = NEWS_API_BASE) {
    const requestedSegments = (categories.length ? categories : fispTvSectionSegments)
        .map((value) => {
            if (typeof value === "string") {
                return findSegmentBySlug(value) || findSegmentByCategory(value);
            }

            return value;
        })
        .filter(Boolean);

    const collections = await Promise.all(
        requestedSegments.map(async (segment) => {
            const items = await fetchCategoryPreviewNews(segment.slug, signal, server);

            return {
                segment,
                items: items.slice(0, limit),
            };
        }),
    );

    return collections;
}

export async function fetchCategoryPageNews(category, page = 1, signal, server = NEWS_API_BASE) {
    const pageResult = await fetchCategoryPageNewsPage(category, page, 10, signal, server);

    return pageResult.items;
}

export async function fetchCategoryPageNewsPage(category, page = 1, pageSize = 10, signal, server = NEWS_API_BASE) {
    const segment = findSegmentByCategory(category) || findSegmentBySlug(category);
    const slug = segment?.slug || slugifyCategory(category);

    if (segment?.slug === "recetas") {
        const result = await fetchJson(buildApiUrl("/noticias-hoy-dto-3", server), signal);

        if (!Array.isArray(result)) {
            return {
                items: [],
                total: 0,
                hasMore: false,
                page,
                pageSize,
                category: segment?.label || category,
            };
        }

        const targetKeys = [segment.sourceCategory, segment.label, ...(segment.aliases || [])]
            .filter(Boolean)
            .map((value) => toCategoryKey(value));

        const filteredItems = result.filter((item) => {
            const rawCategory = normalizeUtf8Text(item?.categoria || "").trim();
            return targetKeys.includes(toCategoryKey(rawCategory));
        });

        const sortedItems = sortNewsByDate(filteredItems);
        const offset = (Math.max(1, page) - 1) * pageSize;
        const pageItems = sortedItems.slice(offset, offset + pageSize);

        return {
            items: normalizeNewsCollection(
                pageItems.map((item) => normalizeNewsPreviewItem(item, segment.label, server)),
                sortNewsByDate,
                server,
            ),
            total: sortedItems.length,
            hasMore: offset + pageItems.length < sortedItems.length,
            page: Number(page) || 1,
            pageSize,
            category: segment?.label || category,
        };
    }

    const result = await fetchJson(
        buildApiUrl(`/noticias-categoria-dto-page/${encodeURIComponent(slug)}?page=${page}&pageSize=${pageSize}`, server),
        signal,
    );

    if (!result || !Array.isArray(result.items)) {
        return {
            items: [],
            total: 0,
            hasMore: false,
            page,
            pageSize,
            category: segment?.label || category,
        };
    }

    return {
        items: normalizeNewsCollection(
            result.items.map((item) => normalizeNewsPreviewItem(item, segment?.label, server)),
            sortNewsByDate,
            server,
        ),
        total: Number(result.total) || 0,
        hasMore: Boolean(result.hasMore),
        page: Number(result.page) || page,
        pageSize: Number(result.pageSize) || pageSize,
        category: segment?.label || category,
    };
}

export function groupNewsByCategory(items = []) {
    const grouped = new Map();

    items.forEach((item) => {
        if (!grouped.has(item.category)) {
            grouped.set(item.category, []);
        }

        grouped.get(item.category).push(item);
    });

    const ordered = fispTvSectionSegments
        .filter((segment) => grouped.has(segment.label))
        .map((segment) => ({
            category: segment.label,
            id: segment.slug,
            items: grouped.get(segment.label).slice(0, 4),
        }));

    grouped.forEach((categoryItems, category) => {
        if (category !== "FISP TV" && !ordered.some((section) => section.category === category)) {
            ordered.push({
                category,
                id: slugifyCategory(category),
                items: categoryItems.slice(0, 4),
            });
        }
    });

    return ordered;
}

export function getHighlightedNews(items = []) {
    const ordered = sortNewsForHighlights(items);
    const highlighted = ordered.slice(0, 7);

    if (highlighted.length) {
        return highlighted;
    }

    return items.slice(0, 7);
}

export function getRelatedNews(article, items = [], limit = 3) {
    if (!article) {
        return [];
    }

    const related = [];
    const usedSlugs = new Set([article.slug]);

    article.relatedSlugs.forEach((slug) => {
        const match = items.find((item) => item.slug === slug);

        if (match && !usedSlugs.has(match.slug)) {
            related.push(match);
            usedSlugs.add(match.slug);
        }
    });

    items.forEach((item) => {
        if (related.length >= limit) {
            return;
        }

        if (item.slug === article.slug || usedSlugs.has(item.slug) || item.category !== article.category) {
            return;
        }

        related.push(item);
        usedSlugs.add(item.slug);
    });

    items.forEach((item) => {
        if (related.length >= limit) {
            return;
        }

        if (item.slug === article.slug || usedSlugs.has(item.slug)) {
            return;
        }

        related.push(item);
        usedSlugs.add(item.slug);
    });

    return related.slice(0, limit);
}
